import Row from "@Containers/components/Row";
import useGetAmenitiesCurrency from "@CheckOrder/features/amenities/hooks/useGetAmenitiesCurrency";
import IconType from "@/types/Icon.type";
import IconTicketAmenity from "@Icons/ticket/amenities/IconTicketAmenity";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {Colors} from "@Styles/Colors.style";

interface SelectedCountAmenityProps {
    totalPricePerAmenity: number
    icon: IconType
    description: string
}

function SelectedCountAmenity(props: SelectedCountAmenityProps) {
    const {
        totalPricePerAmenity,
        icon,
        description,
    } = props

    const {sign} = useGetAmenitiesCurrency() || {}
    const isMobile = useIsMobile()

    return (
        <Row justify center className="selected-amenity">
            <span className="selected-amenity__name">
                {description}
            </span>
            <IconTicketAmenity
                width={isMobile ? "20" : "24"}
                height={isMobile ? "20" : "24"}
                fill={Colors.neutralDarkestColor}
                {...{...icon, className: "selected-amenity__icon"}}
            />
            <div
                className="selected-amenity__price"
            >
                {`${totalPricePerAmenity} ${sign}`}
            </div>
        </Row>
    )
}

export default SelectedCountAmenity